import React, { useState, useRef, useEffect } from "react";
import { Button } from "reactstrap";
import { swalError, confirmSwal } from "../../../swal";
import { sendData } from "../../../../helpers/auth";
import { Aguarde } from "../../../../helpers/general";
import { uriList } from "../../../../helpers/config";
import { connect } from "react-redux";
import GruposAcl from './gruposacl';

const Form = ({ ...props }) => {
  const [gravando, setGravando] = useState(false);
  const [permissoes, setPermissoes] = useState(false);
  const [clickedTr, setClickedTr] = useState({});
  const tableRef = useRef(null);
  const [editar, setEditar] = useState(false);

  useEffect(() => {
    console.log("grupos_permissoes(useEffect)-Components: ", props.grupos);
  }, []);

  // Função para fechar o modal de edição/inclusão e chamar props.refresh
  const handleCloseEdicao = () => {
    setEditar(false);
    if (typeof props.refresh === "function") {
      props.refresh();
    }
  };

  const handleNew = () => {
    setEditar({});
  };

  const handleEdit = async (_grupo) => {
    console.log("grupos_permissoes.handleEdit", _grupo);
    setGravando(true);
    try {
      const res = await sendData({
        uri: uriList("buscarGrupoPermissoes"),
        content: { id: _grupo.id },
        method: "POST"
      });

      console.log("grupos_permissoes.handleEdit(res): ", res);
      if (res.status === 200) {
        setEditar(res.data);
      } else {
        swalError("Erro ao carregar grupo");
      }
    } catch (e) {
      console.log("handleEdit(error): ", e);
      swalError("Erro ao carregar grupo");
    }
    setGravando(false);
  };

  return (
    <>
      {editar &&
        <GruposAcl
          grupo={editar}
          onCloseEv={handleCloseEdicao}
        />
      }

      {gravando && <Aguarde legenda={"Aguarde, gravando dados..."} />}

      <div>
        <div className="col-md-4 py-1 px-0">
          <button
            onClick={handleNew}
            className="btn btn-sm text-light"
            title="Novo Grupo"
            style={{ backgroundColor: "#00bdff" }}
          >
            <i className="mdi mdi-plus-box" />
          </button>
        </div>

        <div className="table1 mt-4">
          <div className="mb-1" style={{
            border: "0.5px solid lightGray",
            borderRadius: "2px",
            padding: "5px",
          }}>
            <table ref={tableRef} className="table table-bordered table-striped">
              <thead>
                <tr style={{ backgroundColor: "#f2f2f2" }}>
                  <th scope="col" className="font-80">#</th>
                  <th scope="col" className="font-80">Nome</th>
                  <th scope="col" className="font-80">Status</th>
                  <th scope="col" className="font-80">Tipo de Usuário</th>
                  <th scope="col" className="font-80">Ações</th>
                </tr>
              </thead>
              <tbody>
                {props.grupos?.length > 0 ? (
                  props.grupos.map((grupo, i) => (
                    <tr
                      key={i}
                      className={clickedTr === grupo.id ? "bg-secondary text-light" : ""}
                      onClick={() => setClickedTr(grupo.id)}
                      onDoubleClick={() => handleEdit(grupo)}
                    >
                      <td>{i + 1}</td>
                      <td>{grupo.nome}</td>
                      <td>{grupo.status}</td>
                      <td>{grupo.tipo_usuario}</td>
                      <td className="text-center" style={{ display: "flex", justifyContent: "space-evenly" }}>
                        <button
                          className="btn btn-sm btn-warning"
                          title="Editar grupo"
                          onClick={() => handleEdit(grupo)}
                        >
                          <i className="mdi mdi-file-edit-outline"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-success"
                          title="Editar permissões"
                          onClick={() => handleEdit(grupo)}
                        >
                          <i className="mdi mdi-account-key"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">Sem dados</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    user: state.dados.user,
  };
}

export default connect(mapStateToProps)(Form);
